import { colors } from 'themes/variables';

export default theme => ({
  bottom: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  padding: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  middle: {
    textAlign: 'center',
  },
  light: {
    color: colors.primary,
    textDecoration: 'none',
  },
  submit: {
    marginTop: 20,
    marginBottom: 20,
  },
  label: {
    marginTop: 20,
  },
});
